import React, { FC, useState } from "react";
import { ReactSortable } from "react-sortablejs";
import "./sortableExerciseList.scss";
import CardMenu from "../CardMenu";
import DeleteAlert from "../../DeleteAlert";
import videoIcon from "../../../../assets/icons/video-chapter-icon.svg";
import pdfIcon from "../../../../assets/icons/pdf-chapter-icon.svg";
import dragTrigger from "../../../../assets/icons/drag-trigger.svg";
import ContentEditForm from "../ContentEditForm";
import ChapterContentViewer from "../ChapterContentViewer";
import ChapterContentService from "../../../../services/CourseServices/ChapterService/chapterContent.service";
import { ExerciseModal } from "../../../../models/ExerciseModal/Exercise.model";
import AddExercise from "../../../../views/CourseStructure/Chapters/AddExercise";
import DisplayExercise from "../../../../views/CourseStructure/Chapters/DisplayExercise";
import excerciseService from "../../../../services/ExcerciseService/excercise.service";
import { RouteComponentProps, withRouter } from "react-router";
import { ExamExerciseService } from "../../../../services/ExamService/ExerciseService/exercise.service";

interface SortableContentListProps extends RouteComponentProps {
	list: any;
	setList: any;
	menuText: string;
	refreshList: Function;
}

const SortableExerciseList: FC<SortableContentListProps> = (props) => {
	const { list, setList, menuText, refreshList } = props;

	const [currentContent, setCurrentContent] = useState<any>();
	const [deleteVisible, setDeleteVisible] = useState<boolean>(false);
	const [formVisible, setFormVisible] = useState<boolean>(false);
	const [showContent, setShowContent] = useState<boolean>(false);

	const handleDelete = () => {
		if (props.location.pathname.includes("exams")) {
			ExamExerciseService.deleteExamExercise(
				currentContent?.id,
				() => {
					refreshList();
					setDeleteVisible(false);
				},
				() => {
					setDeleteVisible(false);
				}
			)
		} else {
			excerciseService.deleteExercise(
				currentContent?.id,
				() => {
					refreshList();
					setDeleteVisible(false);
				}
			).then();
		}
	};

	const handleSort = (e: any) => {
		let data = {
			excercise: {
				position: e.newIndex + 1,
			},
		};

		excerciseService.updatePosition(e.item.dataset.id, data, () => {
			refreshList()
		})
	};

	return (
		<>
			{formVisible && <AddExercise
				visible={formVisible}
				closeModalHandler={() => {
					setCurrentContent(null)
					setFormVisible(false)
				}}
				exercise={currentContent}
				refreshList={refreshList}
			/>}
			<DeleteAlert
				contentTitle={currentContent?.title}
				contentSubject="21 Questions"
				contentThumbnail={
					currentContent?.contentLibrary?.displayPictureUrl
				}
				visible={deleteVisible}
				setVisible={setDeleteVisible}
				deleteText="Exercise"
				handleDelete={handleDelete}
			/>
			<ReactSortable list={list} setList={setList} onSort={handleSort}>
				{list.map((item: any, index: number) => {
					return (
						<div
							key={item.id}
							className="sortable__container sortable__content__container"
						>
							<div className="sortable__trigger">
								<img src={dragTrigger} alt="" />
							</div>
							<div
								className="sortable__card sortable__content__card"
								onClick={() => {
									setCurrentContent(item);
									setShowContent(true);
								}}
							>
								<div >
									<div className="sortable__que__number">
										{index + 1}
									</div>
									<div className="sortable__title sortable__content__title">
										{item?.title}
									</div>
									<div
										className="sortable__menu-trigger sortable__content__menu"
										onClick={(event) => {
											event.stopPropagation();
											setCurrentContent(item);
										}}
									>
										<CardMenu
											menuText={menuText}
											handleEdit={setFormVisible}
											handleDelete={setDeleteVisible}
										/>
									</div>
								</div>
								<div className="sortable__status">
									<span
										className={`sortable__status__indicator ${item?.isActive
											? "active"
											: "inactive"
											}`}
									/>
									{item.isActive ? "Active" : "Inactive"}
								</div>
								<div className="ml-3">ID: {item?.id}</div>
							</div>
						</div>
					);
				})}
			</ReactSortable>
			{showContent && <DisplayExercise
				exercise={currentContent}
				visible={showContent}
				closeModal={() => {
					setShowContent(false);
					setCurrentContent(null)
				}}
			/>}

		</>
	);
};

export default withRouter(SortableExerciseList);
